export const ShieldFilledIcon = ({ size = 24, className = "" }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M18.54 4.12003L13.04 2.06003C12.47 1.85003 11.54 1.85003 10.97 2.06003L5.47 4.12003C4.41 4.52003 3.55 5.76003 3.55 6.89003V14.99C3.55 15.8 4.08 16.87 4.73 17.35L10.23 21.46C11.2 22.19 12.79 22.19 13.76 21.46L19.26 17.35C19.91 16.86 20.44 15.8 20.44 14.99V6.89003C20.45 5.76003 19.59 4.52003 18.54 4.12003ZM15.48 9.72003L11.18 14.02C11.03 14.17 10.84 14.24 10.65 14.24C10.46 14.24 10.27 14.17 10.12 14.02L8.52 12.4C8.23 12.11 8.23 11.63 8.52 11.34C8.81 11.05 9.29 11.05 9.58 11.34L10.66 12.42L14.43 8.65003C14.72 8.36003 15.2 8.36003 15.49 8.65003C15.78 8.94003 15.78 9.43003 15.48 9.72003Z"
      fill="white"
    />
  </svg>
);
